(function () {
  'use strict';

  if (window.__asperariaBraceletTierGiftLoaded) return;

  var CFG = window.aspBraceletGift;
  if (!CFG || CFG.enabled === false) return;

  var VARIANT_IDS = new Set();
  var CONFIG_VARIANTS = [];
  (CFG.variants || []).forEach(function (item) {
    var id = parseInt(item && item.id, 10);
    if (!isFinite(id)) return;
    VARIANT_IDS.add(id);
    CONFIG_VARIANTS.push(item);
  });
  if (!VARIANT_IDS.size) return;

  var GIFT_HANDLES = CFG.giftHandle ? [String(CFG.giftHandle)] : [];

  var DEFAULT_VARIANT_ID = parseInt(CFG.defaultVariantId, 10);
  if (!VARIANT_IDS.has(DEFAULT_VARIANT_ID)) {
    DEFAULT_VARIANT_ID = parseInt(CONFIG_VARIANTS[0].id, 10);
  }

  var CONFIG_MIN_AMOUNT = parseFloat(CFG.minAmount);
  if (!(CONFIG_MIN_AMOUNT > 0)) return;

  window.__asperariaBraceletTierGiftLoaded = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var STORAGE_KEY = 'asp_bracelet_variant_id';

  var GIFT_QTY = 1;
  var SYNC_DEBOUNCE = 500;
  var SELF_QUIET_MS = 1500;
  var MUTATION_BUDGET = 8;
  var MUTATION_WINDOW = 30000;

  var syncTimer = null;
  var syncing = false;
  var swapping = false;
  var quietUntil = 0;
  var lastSig = '';
  var lastMoneySig = '';
  var lastUpcartSig = '';
  var mutationLog = [];

  function getMinAmountUsd() {
    if (typeof window.__aspBraceletMinUsd === 'number' && window.__aspBraceletMinUsd > 0) {
      return window.__aspBraceletMinUsd;
    }
    return CONFIG_MIN_AMOUNT;
  }

  function getSelectedVariantId() {
    var stored = parseInt(localStorage.getItem(STORAGE_KEY) || '', 10);
    return VARIANT_IDS.has(stored) ? stored : DEFAULT_VARIANT_ID;
  }

  /* ---------------------------------------------------------------- item shape */

  function variantIdOf(item) {
    if (!item) return 0;
    var raw = item.variant_id != null ? item.variant_id
      : item.variantId != null ? item.variantId
      : item.id;
    var n = parseInt(raw, 10);
    return isFinite(n) ? n : 0;
  }

  function keyOf(item) {
    return item && item.key != null ? String(item.key) : '';
  }

  function qtyOf(item) {
    var n = parseInt(item && item.quantity, 10);
    return isFinite(n) && n > 0 ? n : 0;
  }

  function isGiftHandle(handle) {
    return GIFT_HANDLES.indexOf(String(handle || '')) !== -1;
  }

  function isBracelet(item) {
    if (!item) return false;
    if (isGiftHandle(item.handle)) return true;
    if (VARIANT_IDS.has(variantIdOf(item))) return true;
    var url = String(item.url || '').toLowerCase();
    for (var i = 0; i < GIFT_HANDLES.length; i++) {
      if (url.indexOf('/products/' + GIFT_HANDLES[i]) !== -1) return true;
    }
    return false;
  }

  function isStoreGiftCard(item) {
    if (!item) return false;
    if (item.gift_card === true) return true;
    if (item.giftCard === true) return true;
    var handle = String(item.handle || item.productHandle || '').toLowerCase();
    if (handle.indexOf('gift-card') !== -1 || handle.indexOf('gift_card') !== -1) return true;
    var url = String(item.url || item.productUrl || '').toLowerCase();
    if (url.indexOf('/products/') !== -1 && url.indexOf('gift-card') !== -1) return true;
    var title = String(item.product_title || item.productTitle || item.title || '').toLowerCase();
    if (title.indexOf('gift card') !== -1) return true;
    return false;
  }

  function cartHasStoreGiftCard(cart) {
    var items = cart && cart.items ? cart.items : [];
    for (var i = 0; i < items.length; i++) {
      if (isStoreGiftCard(items[i]) && !isBracelet(items[i])) return true;
    }
    return false;
  }

  function linePrice(item) {
    if (!item) return 0;
    if (item.line_price != null) return item.line_price;
    if (item.final_line_price != null) return item.final_line_price;
    if (item.finalLinePrice != null) return item.finalLinePrice;
    if (item.linePrice != null) return item.linePrice;
    var qty = qtyOf(item) || 1;
    var unit =
      item.final_price != null ? item.final_price
      : item.finalPrice != null ? item.finalPrice
      : item.discounted_price != null ? item.discounted_price
      : item.discountedPrice != null ? item.discountedPrice
      : item.price != null ? item.price
      : item.originalPrice != null ? item.originalPrice
      : 0;
    return unit * qty;
  }

  function cartTotalPrice(cart) {
    if (!cart) return 0;
    if (typeof cart.total_price === 'number') return cart.total_price;
    if (typeof cart.totalPrice === 'number') return cart.totalPrice;
    if (typeof cart.total === 'number') return cart.total;
    if (typeof cart.totalAfterAllDiscounts === 'number') return cart.totalAfterAllDiscounts;
    return 0;
  }

  function cartTotalDiscount(cart) {
    if (!cart) return 0;
    if (typeof cart.total_discount === 'number') return cart.total_discount;
    if (typeof cart.totalDiscount === 'number') return cart.totalDiscount;
    if (typeof cart.cartTotalDiscount === 'number') return cart.cartTotalDiscount;
    if (typeof cart.totalBeforeDiscounts === 'number' && typeof cart.total === 'number') {
      return Math.max(0, cart.totalBeforeDiscounts - cart.total);
    }
    return 0;
  }

  function cartSig(cart) {
    return (cart && cart.items ? cart.items : [])
      .map(function (item) {
        return variantIdOf(item) + 'x' + qtyOf(item);
      })
      .sort()
      .join('|');
  }

  function upcartSig(cart) {
    return cartSig(cart) + '#' + cartTotalPrice(cart) + '#' + cartTotalDiscount(cart);
  }

  function upcartSigUsable(cart) {
    var items = cart && cart.items ? cart.items : [];
    if (!items.length) return true;
    return cartTotalPrice(cart) > 0;
  }

  function moneySig(cart) {
    var apps = cart && cart.cart_level_discount_applications ? cart.cart_level_discount_applications : [];
    var codes = apps
      .map(function (app) {
        if (!app) return '';
        return String(app.key || app.title || '') + ':' + String(app.total_allocated_amount || 0);
      })
      .sort()
      .join(',');
    return cartTotalPrice(cart) + '#' + cartTotalDiscount(cart) + '#' + codes;
  }

  /* ---------------------------------------------------------------- currency */

  function getShopCurrency() {
    if (window.Shopify && Shopify.currency && Shopify.currency.shop_currency) {
      return String(Shopify.currency.shop_currency).toUpperCase();
    }
    return 'USD';
  }

  function getCartCurrency(cart) {
    if (cart && typeof cart.currency === 'string') return cart.currency.toUpperCase();
    if (cart && cart.currency && cart.currency.iso_code) return String(cart.currency.iso_code).toUpperCase();
    if (window.Shopify && Shopify.currency && Shopify.currency.active) {
      return String(Shopify.currency.active).toUpperCase();
    }
    return getShopCurrency();
  }

  function getShopToPresentmentRate(cart) {
    var cartCur = getCartCurrency(cart);
    var shopCur = getShopCurrency();
    if (cartCur === shopCur) return 1;
    var sc = window.Shopify && Shopify.currency ? Shopify.currency : null;
    var rate = sc && sc.rate != null ? parseFloat(sc.rate) : NaN;
    if (sc && String(sc.active || '').toUpperCase() === cartCur && rate > 0) return rate;
    return NaN;
  }

  function presentmentToShop(amountPresentment, cart) {
    var rate = getShopToPresentmentRate(cart);
    if (!amountPresentment || !rate || rate <= 0) return amountPresentment;
    return amountPresentment / rate;
  }

  function eligibleAmountPresentment(cart) {
    var braceletCents = 0;
    var giftCardCents = 0;
    var itemsCents = 0;

    (cart && cart.items ? cart.items : []).forEach(function (item) {
      var line = linePrice(item);
      if (isBracelet(item)) braceletCents += line;
      else if (isStoreGiftCard(item)) giftCardCents += line;
      else itemsCents += line;
    });

    var presentmentCents = itemsCents;
    var totalDiscount = cartTotalDiscount(cart);
    var totalPrice = cartTotalPrice(cart);
    if (totalDiscount > 0 && typeof totalPrice === 'number') {
      presentmentCents = Math.max(0, totalPrice - braceletCents - giftCardCents);
    }

    return presentmentCents / 100;
  }

  function eligibleAmountShop(cart) {
    var presentment = eligibleAmountPresentment(cart);
    if (getCartCurrency(cart) === getShopCurrency()) return presentment;
    var shop = presentmentToShop(presentment, cart);
    return shop > 0 ? shop : presentment;
  }

  function minThresholdPresentment(cart) {
    var minShop = getMinAmountUsd();
    if (getCartCurrency(cart) === getShopCurrency()) return minShop;
    var rate = getShopToPresentmentRate(cart);
    if (!(rate > 0)) return NaN;
    return Math.ceil(minShop * rate - 1e-9);
  }

  function qualifies(cart) {
    if (cartHasStoreGiftCard(cart)) return false;
    var threshold = minThresholdPresentment(cart);
    if (!isFinite(threshold)) return false;
    return eligibleAmountPresentment(cart) >= threshold - 0.001;
  }

  /* ---------------------------------------------------------------- plan */

  function giftPlan(cart) {
    var items = cart && cart.items ? cart.items : [];
    var gifts = items.filter(isBracelet);
    var updates = {};

    if (!isFinite(minThresholdPresentment(cart))) return { updates: updates, addId: null };

    if (!qualifies(cart)) {
      gifts.forEach(function (item) {
        var k = keyOf(item);
        if (k) updates[k] = 0;
      });
      return { updates: updates, addId: null };
    }

    var target = getSelectedVariantId();

    if (!gifts.length) return { updates: {}, addId: target };

    var keep = null;
    for (var i = 0; i < gifts.length; i++) {
      if (variantIdOf(gifts[i]) === target) { keep = gifts[i]; break; }
    }
    if (!keep) {
      gifts.forEach(function (item) {
        var k = keyOf(item);
        if (k) updates[k] = 0;
      });
      return { updates: updates, addId: target };
    }

    gifts.forEach(function (item) {
      var k = keyOf(item);
      if (!k) return;
      if (item === keep) {
        if (qtyOf(item) !== GIFT_QTY) updates[k] = GIFT_QTY;
      } else {
        updates[k] = 0;
      }
    });

    return { updates: updates, addId: null };
  }

  function cartHasOtherMerchandise(cart) {
    var items = cart && cart.items ? cart.items : [];
    for (var i = 0; i < items.length; i++) {
      var item = items[i];
      if (isBracelet(item) || isStoreGiftCard(item)) continue;
      return true;
    }
    return false;
  }

  function decodeNoticeText(value) {
    var raw = String(value || '');
    if (!raw) return '';
    if (raw.indexOf('&') === -1) return raw;
    var ta = document.createElement('textarea');
    ta.innerHTML = raw;
    return ta.value;
  }

  function giftCardNoticeMessage() {
    return decodeNoticeText(
      window.__aspGiftCardCartNotice ||
        'No free card holder with gift cards.'
    );
  }

  function giftCardSeparateMessage() {
    return decodeNoticeText(
      window.__aspGiftCardSeparateNotice ||
        'Buy gift cards in a separate order.'
    );
  }

  function isBraceletPromoText(text) {
    return /free bracelet|bracelet unlocked|free card holder|card holder unlocked|away from free|checkout to claim|bonus bracelet|bonus card holder/i.test(
      String(text || '')
    );
  }

  function collectNoticeRoots() {
    var roots = [document];
    var host = document.getElementById('upCart');
    if (host && host.shadowRoot) {
      roots.push(host.shadowRoot);
      host.shadowRoot.querySelectorAll('*').forEach(function (el) {
        if (el.shadowRoot) roots.push(el.shadowRoot);
      });
    }
    return roots;
  }

  function setGcHidden(el, hide) {
    if (!el || el.id === 'asp-gc-upcart-banner') return;
    if (el.closest && el.closest('#asp-gc-upcart-banner')) return;
    if (hide) {
      if (!el.hasAttribute('data-asp-gc-hide')) {
        el.setAttribute('data-asp-gc-hide', el.style.display || '');
      }
      el.style.setProperty('display', 'none', 'important');
    } else if (el.hasAttribute('data-asp-gc-hide')) {
      var prev = el.getAttribute('data-asp-gc-hide');
      el.style.removeProperty('display');
      if (prev) el.style.display = prev;
      el.removeAttribute('data-asp-gc-hide');
    }
  }

  function hideUpcartRewardsUi(root, hide) {
    var selectors = [
      '.upcart-internal-rewards',
      '.upcart-public-rewards',
      '[class*="upcart-internal-rewards"]',
      '[class*="upcart-public-rewards"]',
      '[class*="segmented-progress-bar"]',
      '[class*="upcart-internal-rewards__bar"]',
      '[class*="upcart-public-rewards__bar"]'
    ];
    for (var s = 0; s < selectors.length; s++) {
      var found = root.querySelectorAll(selectors[s]);
      for (var i = 0; i < found.length; i++) setGcHidden(found[i], hide);
    }
    var nodes = root.querySelectorAll('*');
    for (var n = 0; n < nodes.length; n++) {
      var el = nodes[n];
      if (!el || el.id === 'asp-gc-upcart-banner') continue;
      var cls = String(el.className || '');
      if (/upcart-(internal|public)-rewards/i.test(cls) || /segmented-progress-bar/i.test(cls)) {
        setGcHidden(el, hide);
      }
    }
  }

  function ensureShadowNoticeStyles(root) {
    if (!root || root.querySelector('#asp-gc-note-style')) return;
    var style = document.createElement('style');
    style.id = 'asp-gc-note-style';
    style.textContent =
      '#asp-gc-upcart-banner.asp-gc-note{box-sizing:border-box;display:flex;align-items:stretch;width:auto;margin:4px 16px 14px;border-radius:8px;overflow:hidden;background:#f7f1ea;box-shadow:inset 0 0 0 1px rgba(52,32,24,.14);font-family:inherit;}' +
      '#asp-gc-upcart-banner .asp-gc-note__rail{flex:0 0 4px;background:#5c3d2e;}' +
      '#asp-gc-upcart-banner .asp-gc-note__content{flex:1 1 auto;padding:10px 12px;}' +
      '#asp-gc-upcart-banner .asp-gc-note__label{margin:0 0 3px;font-size:10px;line-height:1.2;letter-spacing:.08em;text-transform:uppercase;font-weight:700;color:#5c3d2e;}' +
      '#asp-gc-upcart-banner .asp-gc-note__text{margin:0;font-size:13px;line-height:1.35;font-weight:600;color:#241812;}' +
      '#asp-gc-upcart-banner .asp-gc-note__sub{margin:4px 0 0;font-size:12px;line-height:1.35;font-weight:400;color:#5a463c;}' +
      '#asp-gc-upcart-banner[hidden]{display:none!important;}';
    root.appendChild(style);
  }

  function fillNoticeLines(el, on, mixed) {
    if (!el) return;
    el.textContent = '';
    if (!on) {
      el.hidden = true;
      return;
    }
    el.className = 'asp-gc-note';
    var rail = document.createElement('div');
    rail.className = 'asp-gc-note__rail';
    rail.setAttribute('aria-hidden', 'true');
    var content = document.createElement('div');
    content.className = 'asp-gc-note__content';
    var label = document.createElement('p');
    label.className = 'asp-gc-note__label';
    label.textContent = 'Note';
    var line1 = document.createElement('p');
    line1.className = 'asp-gc-note__text';
    line1.textContent = giftCardNoticeMessage();
    content.appendChild(label);
    content.appendChild(line1);
    if (mixed) {
      var line2 = document.createElement('p');
      line2.className = 'asp-gc-note__sub';
      line2.textContent = giftCardSeparateMessage();
      content.appendChild(line2);
    }
    el.appendChild(rail);
    el.appendChild(content);
    el.hidden = false;
  }

  function ensureUpcartBanner(root, on, mixed) {
    ensureShadowNoticeStyles(root);
    var el = root.querySelector('#asp-gc-upcart-banner');
    if (!on) {
      if (el) el.remove();
      return;
    }
    if (!el) {
      el = document.createElement('div');
      el.id = 'asp-gc-upcart-banner';
      el.className = 'asp-gc-note';
      el.setAttribute('role', 'status');
      var mount =
        root.querySelector('.upcart-public-rewards, .upcart-internal-rewards') ||
        root.querySelector('[class*="upcart-public-rewards"]') ||
        root.querySelector('[class*="nnouncement"]') ||
        root.querySelector('header') ||
        root.firstElementChild;
      if (mount && mount.parentNode) mount.parentNode.insertBefore(el, mount);
      else if (root.appendChild) root.appendChild(el);
    }
    fillNoticeLines(el, on, mixed);
  }

  function patchGiftCardNotices() {
    var on = !!window.__aspGiftCardInCart;
    var mixed = !!window.__aspGiftCardMixedCart;

    var pageWrap = document.getElementById('asp-gc-cart-notices');
    if (pageWrap) {
      pageWrap.hidden = !on;
      pageWrap.classList.add('asp-gc-note');
    }
    var pageEl = document.getElementById('asp-gc-cart-notice');
    if (pageEl) {
      pageEl.textContent = giftCardNoticeMessage();
      pageEl.hidden = !on;
      pageEl.classList.add('asp-gc-note__text');
    }
    var separateEl = document.getElementById('asp-gc-cart-separate');
    if (separateEl) {
      separateEl.textContent = giftCardSeparateMessage();
      separateEl.hidden = !mixed;
      separateEl.classList.add('asp-gc-note__sub');
    }

    collectNoticeRoots().forEach(function (root) {
      if (root === document) return;
      hideUpcartRewardsUi(root, on);
      ensureUpcartBanner(root, on, mixed);
    });
  }

  function publishState(cart) {
    window.__aspGiftCardInCart = cartHasStoreGiftCard(cart);
    window.__aspGiftCardMixedCart =
      window.__aspGiftCardInCart && cartHasOtherMerchandise(cart);
    window.__aspBraceletEligibleUsd = eligibleAmountShop(cart);
    window.__aspBraceletQualifies = qualifies(cart);
    window.__aspBraceletThresholdPresentment = minThresholdPresentment(cart);
    window.__aspBraceletEligiblePresentment = eligibleAmountPresentment(cart);
    if (typeof window.aspRefreshSpendPromo === 'function') window.aspRefreshSpendPromo();
    patchGiftCardNotices();
  }

  /* ---------------------------------------------------------------- cart io */

  function getCart() {
    return fetch(ROOT + 'cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    }).then(function (res) {
      if (!res.ok) throw new Error('cart');
      return res.json();
    });
  }

  function upcartCart() {
    if (typeof window.upcartGetCart !== 'function') return null;
    try {
      var cart = window.upcartGetCart();
      if (!cart || !Array.isArray(cart.items)) return null;
      return cart;
    } catch (e) {
      return null;
    }
  }

  function budgetOk() {
    var now = Date.now();
    mutationLog = mutationLog.filter(function (t) { return now - t < MUTATION_WINDOW; });
    if (mutationLog.length >= MUTATION_BUDGET) return false;
    mutationLog.push(now);
    return true;
  }

  function applyUpdates(updates) {
    var keys = Object.keys(updates || {});
    if (!keys.length) return Promise.resolve(null);
    if (!budgetOk()) return Promise.resolve(null);
    return fetch(ROOT + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates })
    }).then(function (res) {
      if (!res.ok) return null;
      return res.json();
    }).catch(function () {
      return null;
    });
  }

  function setQuiet(ms) {
    quietUntil = Date.now() + (typeof ms === 'number' ? ms : SELF_QUIET_MS);
    window.__aspCartQuietUntil = quietUntil;
  }

  function refreshUpcart() {
    setQuiet(SELF_QUIET_MS);
    if (typeof window.upcartRefreshCart === 'function') window.upcartRefreshCart();
  }

  function commit(cart) {
    if (!cart) return;
    publishState(cart);
    lastSig = cartSig(cart);
    lastMoneySig = moneySig(cart);
  }

  function invalidate() {
    lastSig = '';
    lastMoneySig = '';
    lastUpcartSig = '';
  }

  /* ---------------------------------------------------------------- swap colour */

  function swapToGiftVariant(id) {
    swapping = true;
    setQuiet(6000);

    return getCart()
      .then(function (cart) {
        var updates = {};
        var targetLineKey = '';

        (cart.items || []).forEach(function (item) {
          var k = keyOf(item);
          if (!k) return;
          if (!isBracelet(item)) return;
          if (variantIdOf(item) === id) targetLineKey = k;
          else updates[k] = 0;
        });

        if (targetLineKey) updates[targetLineKey] = GIFT_QTY;
        else updates[String(id)] = GIFT_QTY;

        return applyUpdates(updates);
      })
      .then(function (next) {
        if (next) commit(next);
        else invalidate();
        refreshUpcart();
      })
      .catch(function () {
        invalidate();
      })
      .then(function () {
        swapping = false;
        setQuiet(SELF_QUIET_MS);
      });
  }

  window.aspSwapBraceletVariant = function (variantId, props) {
    var id = parseInt(variantId, 10);
    if (!VARIANT_IDS.has(id)) return Promise.resolve(null);
    if (swapping) return Promise.resolve(null);
    if (props && props.isLoading) return Promise.resolve(null);
    if (props && props.rawItem && variantIdOf(props.rawItem) === id) return Promise.resolve(null);
    localStorage.setItem(STORAGE_KEY, String(id));
    return swapToGiftVariant(id);
  };

  /* ---------------------------------------------------------------- sync */

  function sync() {
    if (swapping || syncing || Date.now() < quietUntil) return;

    var fast = upcartCart();
    if (fast) {
      publishState(fast);
      if (upcartSigUsable(fast)) {
        var fsig = upcartSig(fast);
        if (lastSig && fsig === lastUpcartSig) return;
        lastUpcartSig = fsig;
      } else {
        lastUpcartSig = '';
      }
    }

    syncing = true;

    getCart()
      .then(function (cart) {
        publishState(cart);
        var sig = cartSig(cart);
        var msig = moneySig(cart);
        if (sig === lastSig && msig === lastMoneySig) return null;

        var plan = giftPlan(cart);
        var updates = plan.updates || {};
        if (plan.addId) updates[String(plan.addId)] = GIFT_QTY;
        if (Object.keys(updates).length) return applyUpdates(updates);

        lastSig = sig;
        lastMoneySig = msig;
        return null;
      })
      .then(function (next) {
        if (next) {
          commit(next);
          refreshUpcart();
        }
      })
      .catch(function () {})
      .then(function () {
        syncing = false;
      });
  }

  function scheduleSync(delay) {
    if (swapping) return;
    if (syncTimer) clearTimeout(syncTimer);
    syncTimer = setTimeout(sync, typeof delay === 'number' ? delay : SYNC_DEBOUNCE);
  }

  function publishFromUpcartCart() {
    var cart = upcartCart();
    if (cart) publishState(cart);
  }

  function bindUpcart() {
    if (!window.upcartSubscribeCartUpdated) return false;
    window.upcartSubscribeCartUpdated(function () {
      if (swapping) return;
      publishFromUpcartCart();
      scheduleSync(SYNC_DEBOUNCE);
    });
    if (typeof window.upcartSubscribeCartLoaded === 'function') {
      window.upcartSubscribeCartLoaded(function () {
        publishFromUpcartCart();
        scheduleSync(SYNC_DEBOUNCE);
      });
    }
    return true;
  }

  if (!bindUpcart()) {
    var timer = setInterval(function () {
      if (bindUpcart()) clearInterval(timer);
    }, 500);
    setTimeout(function () { clearInterval(timer); }, 15000);
  }

  document.addEventListener('cart:refresh', function () {
    if (swapping) return;
    scheduleSync(SYNC_DEBOUNCE);
  });

  scheduleSync(400);

  var noticeObsTimer = null;
  var noticeObserver = new MutationObserver(function () {
    if (noticeObsTimer) clearTimeout(noticeObsTimer);
    noticeObsTimer = setTimeout(patchGiftCardNotices, 80);
  });
  noticeObserver.observe(document.documentElement, { childList: true, subtree: true, characterData: true });

  window.aspRefreshGiftCardCartNotice = patchGiftCardNotices;

  if (window.__ASP_TEST) {
    window.__aspBraceletGiftTest = {
      isBracelet: isBracelet,
      isStoreGiftCard: isStoreGiftCard,
      cartHasStoreGiftCard: cartHasStoreGiftCard,
      qualifies: qualifies,
      giftPlan: giftPlan,
      cartSig: cartSig,
      moneySig: moneySig,
      minThresholdPresentment: minThresholdPresentment,
      variantIdOf: variantIdOf,
      linePrice: linePrice,
      cartTotalDiscount: cartTotalDiscount,
      eligibleAmountPresentment: eligibleAmountPresentment,
      GIFT_HANDLES: GIFT_HANDLES,
      VARIANT_IDS: VARIANT_IDS,
      DEFAULT_VARIANT_ID: DEFAULT_VARIANT_ID
    };
  }
})();
